export default "__VITE_ASSET__BfPnQZ3g__"